"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class SearchIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "20px", height: "20px", viewBox: "0 0 20 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: fill, strokeWidth: "2", fill: "none", fillRule: "evenodd" },
                React.createElement("g", { fill: "none" },
                    React.createElement("path", { d: "M13.727 8.545a5.182 5.182 0 1 0-10.364.001 5.182 5.182 0 0 0 10.364 0z" }),
                    React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M13 13l3.311 3.31" })))));
    }
}
exports.SearchIcon = SearchIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/search.tsx
// module id = 2163
// module chunks = 0 1 2